import { IsNotEmpty, IsUUID, IsOptional, IsBoolean } from 'class-validator';

export class GetEventDto {
  @IsNotEmpty()
  @IsUUID()
  id: string;

  @IsOptional()
  @IsBoolean()
  isCandidate?: boolean;

  @IsOptional()
  @IsBoolean()
  shouldRedirect?: boolean;

  @IsOptional()
  @IsBoolean()
  blink?: boolean;
}
